export const KEY = 'performance';
export const PARAM_KEY = 'performanceId';
